export const categories = [
  {
    label: "Primed Boards",
    subcategories: [
      {
        productCode: 12434,
        name: "1 X 4 - 16'  S4S Mdf Primed Boards",
      },
      {
        productCode: 12435,
        name: "1 X 6 - 16'   S4S Mdf Primed Boards",
      },
      {
        productCode: 13923,
        name: "1 X 4 - 16'  E2E Mdf Primed Boards",
      },
      {
        productCode: 13924,
        name: "1 X 8 - 16'   E2E Mdf Primed Boards",
      },
      {
        productCode: 34869,
        name: "1 X 12 - 16'  E2E Mdf Primed Boards",
      },
      {
        productCode: 40811,
        name: "1 X 6 - 16'   E2E Mdf Primed Boards",
      },
      {
        productCode: 40887,
        name: "1 X 4 - 16'   Windsor One Board",
      },
      {
        productCode: 40888,
        name: "1 X 6 - 16'   Windsor One Board",
      },
      {
        productCode: 40889,
        name: "1 X 8 - 16'   Windsor One Board",
      },
      {
        productCode: 40890,
        name: "1 X 12 - 16'  Windsor One Board",
      },
      {
        productCode: 43391,
        name: "1 X 10 - 16'  Windsor One Board",
      },
      {
        productCode: 50360,
        name: "5/4 X 4 - 16' Primed Fj Pine S4S",
      },
      {
        productCode: 40891,
        name: "*** 1X6-16' Windsor One traditional beaded WOSPBC6",
      },
      {
        productCode: 43505,
        name: "primed FJ casing E2E WM412 - 11/16 x 3-1/2  - 16'",
      },
      {
        productCode: 43504,
        name: "primed FJ pine base E1E OL430 - 9/16 x 4-1/4 - 16' pc",
      },
      {
        productCode: 30036,
        name: "primed FJP base E1E L514/O1236 - 9/16 x 5-1/4 -16",
      },
    ],
  },
  {
    label: "Pine Boards",
    subcategories: [
      {
        productCode: 7112,
        name: "1 X 4 - 8'   C&Btr Pine",
      },
      {
        productCode: 7114,
        name: "1 X 4 - 10'  C&Btr Pine",
      },
      {
        productCode: 7116,
        name: "1 X 4 - 12'  C&Btr Pine",
      },
      {
        productCode: 7118,
        name: "1 X 4 - 14'  C&Btr Pine",
      },
      {
        productCode: 7120,
        name: "1 X 4 - 16'  C&Btr Pine",
      },
      {
        productCode: 7126,
        name: "1 X 6 - 8'   C&Btr Pine",
      },
      {
        productCode: 7128,
        name: "1 X 6 - 10'  C&Btr Pine",
      },
      {
        productCode: 7130,
        name: "1 X 6 - 12'  C&Btr Pine",
      },
      {
        productCode: 7132,
        name: "1 X 6 - 14'  C&Btr Pine",
      },
      {
        productCode: 7134,
        name: "1 X 6 - 16'  C&Btr Pine",
      },
      {
        productCode: 7140,
        name: "1 X 8 - 8'   C&Btr Pine",
      },
      {
        productCode: 7142,
        name: "1 X 8 - 10'  C&Btr Pine",
      },
      {
        productCode: 7144,
        name: "1 X 8 - 12'  C&Btr Pine",
      },
      {
        productCode: 7146,
        name: "1 X 8 - 14'  C&Btr Pine",
      },
      {
        productCode: 7148,
        name: "1 X 8 - 16'  C&Btr Pine",
      },
      {
        productCode: 7154,
        name: "1 X 10 - 8'  C&Btr Pine",
      },
      {
        productCode: 7158,
        name: "1 X 10 - 12' C&Btr Pine",
      },
      {
        productCode: 7160,
        name: "1 X 10 - 14' C&Btr Pine",
      },
      {
        productCode: 7162,
        name: "1 X 10 - 16' C&Btr Pine",
      },
      {
        productCode: 7168,
        name: "1 X 12 - 8'  C&Btr Pine",
      },
      {
        productCode: 7170,
        name: "1 X 12 - 10' C&Btr Pine",
      },
      {
        productCode: 7172,
        name: "1 X 12 - 12' C&Btr Pine",
      },
      {
        productCode: 7174,
        name: "1 X 12 - 14' C&Btr Pine",
      },
      {
        productCode: 7176,
        name: "1 X 12 - 16' C&Btr Pine",
      },
    ],
  },
  {
    label: "Oak & Poplar Boards",
    subcategories: [
      {
        productCode: 40691,
        name: "1 X 4 - 8'   S4S Poplar",
      },
      {
        productCode: 40693,
        name: "1 X 4 - 10'  S4S Poplar",
      },
      {
        productCode: 40694,
        name: "1 X 4 - 11'  S4S Poplar",
      },
      {
        productCode: 40696,
        name: "1 X 4 - 12'  S4S Poplar",
      },
      {
        productCode: 40697,
        name: "1 X 4 - 13'  S4S Poplar",
      },
      {
        productCode: 40698,
        name: "1 X 4 - 14'  S4S Poplar",
      },
      {
        productCode: 40699,
        name: "1 X 4 - 15'  S4S Poplar",
      },
      {
        productCode: 40700,
        name: "1 X 4 - 16'  S4S Poplar",
      },
      {
        productCode: 40706,
        name: "1 X 6 - 8'   S4S Poplar",
      },
      {
        productCode: 40708,
        name: "1 X 6 - 10'  S4S Poplar",
      },
      {
        productCode: 40710,
        name: "1 X 6 - 12'  S4S Poplar",
      },
      {
        productCode: 40712,
        name: "1 X 6 - 14'  S4S Poplar",
      },
      {
        productCode: 40713,
        name: "1 X 6 - 15'  S4S Poplar",
      },
      {
        productCode: 40714,
        name: "1 X 6 - 16'  S4S Poplar",
      },
      {
        productCode: 40721,
        name: "1 X 8 - 8'   S4S Poplar",
      },
      {
        productCode: 40723,
        name: "1 X 8 - 10'  S4S Poplar",
      },
      {
        productCode: 40725,
        name: "1 X 8 - 12'  S4S Poplar",
      },
      {
        productCode: 40727,
        name: "1 X 8 - 14'  S4S Poplar",
      },
      {
        productCode: 40729,
        name: "1 X 8 - 16'  S4S Poplar",
      },
      {
        productCode: 39320,
        name: "1 X 10 - 8'  S4S Poplar",
      },
      {
        productCode: 39327,
        name: "1 X 10 - 16' S4S Poplar",
      },
      {
        productCode: 780,
        name: "1 X 10 - 12' S4S Poplar",
      },
      {
        productCode: 20266,
        name: "1 X 12 - 8'  S4S Poplar",
      },
      {
        productCode: 21414,
        name: "1 X 12 - 7'  S4S Poplar",
      },
      {
        productCode: 21416,
        name: "1 X 12 - 10' S4S Poplar",
      },
      {
        productCode: 21418,
        name: "1 X 12 - 12' S4S Poplar",
      },
      {
        productCode: 21419,
        name: "1 X 12 - 14' S4S Poplar",
      },
      {
        productCode: 21421,
        name: "1 X 12 - 16' S4S Poplar",
      },
      {
        productCode: 40462,
        name: "1 X 4 - 8'   S4S Red Oak",
      },
      {
        productCode: 40464,
        name: "1 X 4 - 10'  S4S Red Oak",
      },
      {
        productCode: 40465,
        name: "1 X 4 - 11'  S4S Red Oak",
      },
      {
        productCode: 40466,
        name: "1 X 4 - 12'  S4S Red Oak",
      },
      {
        productCode: 40468,
        name: "1 X 4 - 14'  S4S Red Oak",
      },
      {
        productCode: 40470,
        name: "1 X 4 - 16'  S4S Red Oak",
      },
      {
        productCode: 40644,
        name: "1 X 6 - 7'   S4S Red Oak",
      },
      {
        productCode: 40645,
        name: "1 X 6 - 8'   S4S Red Oak",
      },
      {
        productCode: 40649,
        name: "1 X 6 - 10'  S4S Red Oak",
      },
      {
        productCode: 40651,
        name: "1 X 6 - 12'  S4S Red Oak",
      },
      {
        productCode: 40653,
        name: "1 X 6 - 14'  S4S Red Oak",
      },
      {
        productCode: 40656,
        name: "1 X 6 - 16'  S4S Red Oak",
      },
      {
        productCode: 40666,
        name: "1 X 8 - 8'   S4S Red Oak",
      },
      {
        productCode: 40668,
        name: "1 X 8 - 10'  S4S Red Oak",
      },
      {
        productCode: 40673,
        name: "1 X 8 - 12'  S4S Red Oak",
      },
      {
        productCode: 40676,
        name: "1 X 8 - 14'  S4S Red Oak",
      },
      {
        productCode: 40677,
        name: "1 X 8 - 15'  S4S Red Oak",
      },
      {
        productCode: 40678,
        name: "1 X 8 - 16'  S4S Red Oak",
      },
      {
        productCode: 35168,
        name: "1 X 12 - 8'  S4S Red Oak",
      },
      {
        productCode: 35172,
        name: "1 X 12 - 12' S4S Red Oak",
      },
    ],
  },
  {
    label: "Primed & MDF Mouldings",
    subcategories: [
      {
        productCode: 12246,
        name: "primed MDF crown cove 93265 - 9/16 x 4-1/4 LF",
      },
      {
        productCode: 19919,
        name: "primed FJ pine stop col WM936 - 7/16 x 1-3/8 - LF",
      },
      {
        productCode: 19923,
        name: "primed FJ pine stop rnd edge WM876 - 7/16 x 1-3/8 - 7'",
      },
      {
        productCode: 19924,
        name: "primed FJ pine stop col WM936 - 7/16 x 1-3/8 - 7'",
      },
      {
        productCode: 20801,
        name: "primed FJ pine casing victorian #450 - 11/16 x 3-1/2 - LF",
      },
      {
        productCode: 23416,
        name: "primed FJ pine chair rail WM390 - 11/16 x 2-1/2 LF",
      },
      {
        productCode: 36690,
        name: "primed FJ pine base shoe WM126 - 1/2 x 3/4 LF",
      },
      {
        productCode: 36800,
        name: "primed FJP base colonial OW623 - 9/16 x 3-1/4 LF",
      },
      {
        productCode: 42614,
        name: "primed FJ polar crown #BC -3/4 x 4-1/4 LF",
      },
      {
        productCode: 44893,
        name: "primed MDF casing #OP380 - 3/4 x 2-3/4 LF",
      },
      {
        productCode: 44894,
        name: "primed MDF casing 93112 - 3/4 x 3-1/2 LF",
      },
      {
        productCode: 44895,
        name: "primed MDF base colonial 92136 - 5/8 x 4-1/4 LF",
      },
      {
        productCode: 45626,
        name: "primed MDF crown colonial 94047 - 5/8 x 4-1/4 LF",
      },
      {
        productCode: 45846,
        name: "primed FJ pine quarter rd. WM105 - 3/4 x 3/4 LF",
      },
      {
        productCode: 45932,
        name: "primed MDF step casing #OL745 - 3/4 x 3-1/4 LF",
      },
      {
        productCode: 46198,
        name: "primed FJP base victorian 00LK4 - 9/16 x 4-1/4 LF",
      },
      {
        productCode: 46307,
        name: "primed FJ pine casing victorian GM457 - 11/16 x 2-3/4 LF",
      },
      {
        productCode: 46517,
        name: "primed FJ pine base victorian WP163 - 9/16 x 5-1/4 LF",
      },
      {
        productCode: 47948,
        name: "primed FJP base vict. #72135 - 9/16 x 3-1/4 LF",
      },
      {
        productCode: 49204,
        name: 'primed FJ pine stop rnd edge WM876 - 7/16 x 1-3/8 - 98"',
      },
      {
        productCode: 49442,
        name: "primed MDF casing col.l WM356 - 5/8 x 2-1/4 LF",
      },
      {
        productCode: 661,
        name: "primed FJ brick mould WM180 - 1-1/4 x 2 - LF",
      },
      {
        productCode: 7985,
        name: "Jesso primed crown LWM 48 - 9/16 x 4-1/4 LF",
      },
      {
        productCode: 7990,
        name: "Jesso primed crown LWM51 - 9/16 x 3-1/4 LF",
      },
      {
        productCode: 7991,
        name: "primed FJP base colonial OW620 - 9/16 x 4-1/4 LF",
      },
      {
        productCode: 7992,
        name: "primed jesso FJ pine casing colonial WM444 - 11/16 x 3-1/4 LF",
      },
      {
        productCode: 7996,
        name: "Jesso primed crown LWM49 - 9/16 x 3-5/8 LF",
      },
      {
        productCode: 7997,
        name: "primed casing colonial WM356 - 11/16 x 2-1/4 -7'",
      },
      {
        productCode: 7998,
        name: "primed casing colonial WM356 - 11/16 x 2-1/4 LF",
      },
      {
        productCode: 7999,
        name: "primed FJP base colonial WM634 - 7/16 x 3  LF",
      },
      {
        productCode: 43506,
        name: "primed FJ pine craftsman base shoe WM254- 7/16 x 3/4 LF",
      },
    ],
  },
  {
    label: "White Pine Mouldings",
    subcategories: [
      {
        productCode: 13567,
        name: "pine base colonial WM #623 - 9/16 x 3-1/4 LF",
      },
      {
        productCode: 13834,
        name: "primed MDF casing E2E 90432 - 5/8 x 3-1/2 - LF",
      },
      {
        productCode: 13835,
        name: "primed MDF base E2E 121X6 - 1/2 x 5-1/2 LF",
      },
      {
        productCode: 19920,
        name: "pine stop round edge Wp #876 - 7/16 x 1-3/8 - 7'",
      },
      {
        productCode: 19922,
        name: "pine stop colonial WP #936 - 7/16 x 1-3/8 - 7'",
      },
      {
        productCode: 655,
        name: "pine baluster WP #239 - 3/4 x 3/4 - LF",
      },
      {
        productCode: 656,
        name: "pine baluster WP #238  - 1-1/16 x 1-1/16 LF",
      },
      {
        productCode: 657,
        name: "pine base colonial WM #633 - 7/16 x 3-1/4 LF",
      },
      {
        productCode: 658,
        name: "pine base ranch WM #723 - 7/16 x 3-1/4 LF",
      },
      {
        productCode: 659,
        name: "pine shoe WP #126  -1/2 x 3/4 LF",
      },
      {
        productCode: 662,
        name: "pine casing colonial WM #356 - 11/16 x 2-1/4 -LF",
      },
      {
        productCode: 663,
        name: "pine casing ranch WM #327 - 11/16 x 2-1/4 LF",
      },
      {
        productCode: 664,
        name: "pine chair rail colonial LWM #390 - 11/16 x 2-1/2 LF",
      },
      {
        productCode: 665,
        name: "pine chair rail colonial LWM #390 - 11/16 x 2-1/2 LF",
      },
      {
        productCode: 666,
        name: "pine corner guard WM #206 - 3/4 x 3/4 LF",
      },
      {
        productCode: 667,
        name: "pine corner guard WM #205 - 1-1/8 x 1-1/8 LF",
      },
      {
        productCode: 668,
        name: "pine cove WP #101  - 1/2 x 1/2 LF",
      },
      {
        productCode: 669,
        name: "pine cove WP #101  - 1/2 x 1/2 LF",
      },
      {
        productCode: 670,
        name: "pine cove WP #94 - 11/16 x 1-1/8 LF",
      },
      {
        productCode: 672,
        name: "pine cove WM #84 - 9/16 x 2-1/4 LF",
      },
      {
        productCode: 675,
        name: "pine crown WM #54 - 9/16 x 2-1/4 LF",
      },
      {
        productCode: 680,
        name: "full round LWP #233 - 1-1/4 LF",
      },
      {
        productCode: 682,
        name: "handrail flat bottom WM #231 - 1-1/2 x 1-11/16 LF",
      },
      {
        productCode: 683,
        name: "pine lattice LWM #268 - 1/4 x 1-1/8 LF",
      },
      {
        productCode: 684,
        name: "pine lattice LWM #267 - 1/4 x 1-3/8 LF",
      },
      {
        productCode: 685,
        name: "pine lattice LWM #265 - 1/4 x 1-3/4 LF",
      },
      {
        productCode: 687,
        name: "pine quarter round WM #108 - 1/2 x 1/2 - LF",
      },
      {
        productCode: 688,
        name: "pine quarter round WM #105 - 3/4 x 3/4 LF",
      },
      {
        productCode: 690,
        name: "pine screen mould flat WP #142 - 1/4 x 3/4 LF",
      },
      {
        productCode: 691,
        name: "pine screen mould fluted WP #144  - 1/4 x 3/4 LF",
      },
      {
        productCode: 692,
        name: "pine parting stop WP #254  - 1/2 x 3/4 LF",
      },
      {
        productCode: 693,
        name: "pine screen stock WM #248  - 11/16 x 1-3/4 LF",
      },
      {
        productCode: 694,
        name: "pine screen stock LWP #246 - 11/16 x 2-3/4 LF",
      },
      {
        productCode: 701,
        name: "pine stop ranch WP #846 - 7/16 x 1-3/8 LF",
      },
      {
        productCode: 702,
        name: "pine stop ranch WP #845 - 7/16 x 1-5/8 LF",
      },
      {
        productCode: 704,
        name: "pine stop round edge WP #876 - 7/16 x 1-3/8 LF",
      },
      {
        productCode: 7047,
        name: "pine crown LWM #48 - 9/16 x 4-1/4 LF",
      },
      {
        productCode: 705,
        name: "pine stop round edge WP #875 - 7/16 x 1-5/8 LF",
      },
      {
        productCode: 706,
        name: "pine stop colonial WP #936 - 7/16 x 1-3/8 LF",
      },
      {
        productCode: 708,
        name: "pine panel mould # 185 - 9/16 x 1-1/2 LF",
      },
      {
        productCode: 710,
        name: "pine mullion colonial WM #987 - 3/8 x 2 LF",
      },
      {
        productCode: 713,
        name: "pine lattice LWM #264  - 1/4 x 2 LF",
      },
      {
        productCode: 714,
        name: "pine casing colonial L #444 - 11/16 x 3-1/4 LF",
      },
      {
        productCode: 724,
        name: "pine lattice LWM #263 - 5/16 x 5-1/2 LF",
      },
      {
        productCode: 779,
        name: "pine casing ranch WM #327 - 11/16 x 2-1/4 -7' side",
      },
      {
        productCode: 783,
        name: "pine corner guard WM #204 - 1-5/16 x 1-5/16 LF",
      },
      {
        productCode: 7852,
        name: "pine crown WP #51 - 9/16 x 3-1/4 LF",
      },
      {
        productCode: 787,
        name: "pine casing colonial WM #356 - 11/16 x 2-1/4 -7' side",
      },
      {
        productCode: 799,
        name: "pine base colonial WM #620 - 9/16 x 4-1/4 LF",
      },
      {
        productCode: 86,
        name: "primed FJ casing E2E WM412 - 11/16 x 3-1/2  - 16'",
      },
    ],
  },
  {
    label: "Oak & Poplar Mouldings",
    subcategories: [
      {
        productCode: 12184,
        name: "clear poplar casing CCA225S - 1/2 x 2-1/4 LF",
      },
      {
        productCode: 12185,
        name: "clear poplar casing CCA275S - 1/2 x 2-3/4 LF",
      },
      {
        productCode: 12220,
        name: "FJ poplar casing E2E BC-E2E - 3/4 x 3-1/2 LF",
      },
      {
        productCode: 12276,
        name: "clear poplar hand rail L #230 - 1-1/4 x 2 - 16",
      },
      {
        productCode: 12683,
        name: "clear poplar casing BC-1510 - 3/4 x 2-3/4 -LF",
      },
      {
        productCode: 40365,
        name: "clear poplar casing victorian BC-771 - 11/16 x 3-1/2 LF",
      },
      {
        productCode: 40417,
        name: "clear poplar cove WM #93 - 3/4 x 3/4 LF",
      },
      {
        productCode: 40418,
        name: "clear poplar shoe WM #126 - 1/2 x 3/4 LF",
      },
      {
        productCode: 41988,
        name: "FJ poplar casing ornate BC-951 - 3/4 x 2-3/4 LF ",
      },
      {
        productCode: 43236,
        name: "FJ poplar casing BC-098 - 3/4 x 3-1/2 LF",
      },
      {
        productCode: 48689,
        name: "FJ poplar casing step BC-780 - 3/4 x 2-3/4 LF",
      },
      {
        productCode: 49475,
        name: "clear poplar stop round edge E2E #887 - 3/8 x 1-1/4 - 7'",
      },
      {
        productCode: 7885,
        name: "oak corner guard WM #206 - 3/4 x 3/4 LF",
      },
      {
        productCode: 928,
        name: "oak stop ranch WM #846 - 7/16 x 1-3/8 LF",
      },
      {
        productCode: 24060,
        name: "oak crown WM49 - 11/16 x 3-5/8 LF",
      },
      {
        productCode: 24061,
        name: "oak casing colonial LWM #356 - 9/16 x 2-1/4 LF",
      },
      {
        productCode: 24062,
        name: "oak casing colonial D #356A - 5/8 x 2-1/4 -7' ",
      },
      {
        productCode: 24063,
        name: "oak base colonial LWM #634 - 3/8 x 3 LF",
      },
      {
        productCode: 24066,
        name: "oak chair rail WM #390 - 5/8 x 2-1/2 LF",
      },
      {
        productCode: 40058,
        name: "oak cove WM #93 - 3/4 x 3/4 LF ",
      },
      {
        productCode: 41503,
        name: "oak base shoe WM #126 - 1/2 x 3/4 LF ",
      },
      {
        productCode: 41585,
        name: "oak quarter round WM #105 - 3/4 x 3/4 LF ",
      },
      {
        productCode: 41641,
        name: "oak stop colonial WM #947 - 3/8 x 1-1/4 LF",
      },
      {
        productCode: 41642,
        name: "oak stop colonial WM #947 - 3/8 x 1-1/4 - 7'",
      },
    ],
  },
  {
    label: "Door Jambs",
    subcategories: [
      {
        productCode: 13506,
        name: "#4 9/16 F.J.Prmd Jamb Side(Sgl), primed jamb",
      },
      {
        productCode: 13507,
        name: "#4 9/16 Clr.Veneer Jamb Side Sng",
      },
      {
        productCode: 13510,
        name: "4 9/16 Solid Jamb Side (Single)",
      },
      {
        productCode: 13511,
        name: '#5" Clear Split Jamb Side',
      },
      {
        productCode: 13513,
        name: '# 5" Primed Fj Split Jamb',
      },
      {
        productCode: 13516,
        name: "# 6-9/16 Clear Flat Jamb Side",
      },
      {
        productCode: 13518,
        name: '#6 9/16" F/J Primed Jamb Side',
      },
      {
        productCode: 47480,
        name: "6-9/16 x 6/10 Solid Poplar Flat Jamb Side",
      },
      {
        productCode: 49439,
        name: "4-7/8 x 6/8 FJ Primed Jamb Side (single)",
      },
      {
        productCode: 49474,
        name: "4-9/16 x 6/10 Solid Poplar Flat Jamb Side",
      },
    ],
  },
  {
    label: "Shelving & Brackets",
    subcategories: [
      {
        productCode: 1009416,
        name: '12" x 97" SQ. EDGE PART BD WHITE MELAMINE SHELF W2S 1LE',
      },
      {
        productCode: 1009495,
        name: '12" X 145" SQ EDGE PART BD WHITE MELAMINE SHELF W2S 1LE',
      },
      {
        productCode: 1009417,
        name: '16" X 97" SQ EDGE PART BD WHITE MELAMINE SHELF W2S 1LE',
      },
      {
        productCode: 20845,
        name: '16" X 145" SQ EDGE PART BD WHITE MELAMINE SHELF W2S 1LE',
      },
      {
        productCode: 214892,
        name: "0045-White/Shelf Rod Bracket",
      },
      {
        productCode: 214914,
        name: '30"-48" White Adj Closet Rod',
      },
      {
        productCode: 214930,
        name: "John Sterling Closet-Pro 48 In. to 72 In. x 1-1/4 In. Extra Heavy-Duty Adjustable Closet Rod, White   RP-0021-48/72",
      },
      {
        productCode: 214949,
        name: "John Sterling Closet-Pro 72 In. to 120 In. x 1-1/4 In. Extra Heavy-Duty Adjustable Closet Rod, White    RP-0021-72/120",
      },
      {
        productCode: 49160,
        name: "74305 Wt Hd Shelf/Rod Brkt White =010",
      },
      {
        productCode: 214906,
        name: "0046-Wt Brkt,Shelf Wht Sterling",
      },
    ],
  },
  {
    label: "Door Track",
    subcategories: [
      {
        productCode: 1097,
        name: "153068PF 3'0\"X6'8\"   2x4 wall  Pocket Door Frame Kit",
      },
      {
        productCode: 215001,
        name: "Johnson 72 In. 4-Door Folding Door Hardware   1700726H",
      },
      {
        productCode: 215029,
        name: "Johnson  60 In. 4-Door Folding Door Hardware   1700606H",
      },
      {
        productCode: 215065,
        name: "Johnson 48 In. 4-Door Folding Door Hardware   1700486H",
      },
      {
        productCode: 218222,
        name: "Johnson Aluminum 72 In. Bypass Door Hardware Set  2200722D",
      },
      {
        productCode: 218259,
        name: "Johnson Aluminum 60 In. Bypass Door Hardware Set  2200602D",
      },
      {
        productCode: 218375,
        name: "Johnson Aluminum 48 In. Bypass Door Hardware Set   2200482D",
      },
      {
        productCode: 244465,
        name: "Johnson Hardware 1510 Series 36 In. To 80 In. Natural Pocket Door Frame   15113068",
      },
      {
        productCode: 35202,
        name: 'Johnson 22224-72 Bypass Track     9/16" Jamb',
      },
      {
        productCode: 14000,
        name: "BIFOLD TRACK TEMPO 4/0 BROWN  #1825",
      },
      {
        productCode: 14001,
        name: "BIFOLD TRACK TEMPO 5/0 BROWN  #1825",
      },
      {
        productCode: 14002,
        name: "BIFOLD TRACK TEMPO 6/0 BROWN  #1825",
      },
      {
        productCode: 14003,
        name: "BIFOLD 2RD HDWR TEMP  #1825",
      },
    ],
  },
  {
    label: "Hardware",
    subcategories: [
      {
        productCode: 13433,
        name: "31714-3 Ball Catch, Brite Brass",
      },
      {
        productCode: 13435,
        name: "31714-26D Ball Catch, Sat.Chrome",
      },
      {
        productCode: 13533,
        name: "31714-10B Ball Catch, O.R.Bronze",
      },
      {
        productCode: 13534,
        name: "31714-15 Ball Catch,Satin Nickel",
      },
      {
        productCode: 15557,
        name: "PLS24PRO - MAGNETIC SATCH - BLACK",
      },
      {
        productCode: 15558,
        name: "PLS24PRO - MAGNETIC SATCH - STAINLESS/NICKEL",
      },
      {
        productCode: 14947,
        name: "3151-19  Matte Black Pin Stop",
      },
      {
        productCode: 5212,
        name: "31500-3 B.Brass Hinge Pin Stop",
      },
      {
        productCode: 5213,
        name: "31500-5 Ant.Brass Hinge Pin Stop",
      },
      {
        productCode: 5214,
        name: "31500-26D S.Chrome Hinge Pin Stop",
      },
      {
        productCode: 5215,
        name: "31500-15A A.Nickel Hinge Pin Stop",
      },
      {
        productCode: 5216,
        name: "31500-15 S.Nickel Hinge Pin Stop",
      },
      {
        productCode: 5218,
        name: "31500-10B O.R.Brz Hinge Pin Stop",
      },
      {
        productCode: 51166,
        name: "Hinge Pin Stop Heavy Duty Brass",
      },
      {
        productCode: 51167,
        name: "Hinge Pin Stop Heavy Duty       Antique Brass",
      },
      {
        productCode: 51169,
        name: "Hinge Pin Stop Heavy Duty       Satin Nickel",
      },
      {
        productCode: 51170,
        name: "Hinge Pin Stop Heavy Duty       Satin Chrome",
      },
      {
        productCode: 45058,
        name: "31511-19 Heavy Duty Spring Door Stop Matte Black",
      },
      {
        productCode: 47097,
        name: "Mp3150704 Ridgid Base Stop",
      },
      {
        productCode: 5206,
        name: "31511-3 Bright Brass Spring Stop",
      },
      {
        productCode: 5207,
        name: "31511-5 Ant. Brass Spring Stop",
      },
      {
        productCode: 5208,
        name: "31511-26D Sat.Chrome Spring Stop",
      },
      {
        productCode: 5209,
        name: "31511-15A Ant.Nickel Spring Stop",
      },
      {
        productCode: 5210,
        name: "31511-15 Sat. Nickel Spring Stop",
      },
      {
        productCode: 5211,
        name: "31511-10B O.R.Bronze Spring Stop",
      },
      {
        productCode: 5200,
        name: "30130-3 B.Brass Handrail Bracket",
      },
      {
        productCode: 5201,
        name: "30130-5 Ant.Brass H.Rail Bracket",
      },
      {
        productCode: 5202,
        name: "30130-26D S.Chrome Handrail Brkt",
      },
      {
        productCode: 5203,
        name: "30130-15A Ant.Nickel H.Rail Brkt",
      },
      {
        productCode: 5204,
        name: "30130-15 S.Nickel Handrail Brkt",
      },
      {
        productCode: 5205,
        name: "30130-10B O.R.Bronze H.Rail Brkt",
      },
      {
        productCode: 14945,
        name: "30130-19 Matte Black Handrail Brkt",
      },
      {
        productCode: 12590,
        name: '4" Dull Chrome Hinge',
      },
      {
        productCode: 12591,
        name: '4" Bright Brass Hinge',
      },
      {
        productCode: 14944,
        name: '4" Matte Black Hinge',
      },
      {
        productCode: 30950,
        name: '4" Dull Brass Hinge',
      },
      {
        productCode: 46846,
        name: '4" Satin Nickel Hinge',
      },
      {
        productCode: 46847,
        name: '4" Oil Rubber Bronze Hinge',
      },
      {
        productCode: 12592,
        name: '3 1/2" Polished Chrome Hinge',
      },
      {
        productCode: 12593,
        name: '3 1/2" Brite Brass Hinge Hinge',
      },
      {
        productCode: 12594,
        name: '3 1/2" Dull Chrome Hinge',
      },
      {
        productCode: 12595,
        name: '3 1/2" Antique Brass Hinge',
      },
      {
        productCode: 12596,
        name: '3 1/2" Antique Nickel Hinge',
      },
      {
        productCode: 12597,
        name: '3 1/2" Satin Nickel Hinge',
      },
      {
        productCode: 12598,
        name: '3 1/2" Oil Rubbed Bronze Hinge',
      },
      {
        productCode: 13780,
        name: '3 1/2" Black Hinge',
      },
      {
        productCode: 5224,
        name: "Bright Brass Screw Packs",
      },
      {
        productCode: 5225,
        name: "Antique Brass Screw Packs",
      },
      {
        productCode: 5226,
        name: "Bronze Screw Packs  also use for Black Hinges",
      },
      {
        productCode: 5227,
        name: "Satin Nickel Screw Packs",
      },
      {
        productCode: 5228,
        name: "Antique Nickel Screw Packs",
      },
      {
        productCode: 5229,
        name: "Satin Chrome Screw Packs  also use for Bright Chrome Hinges",
      },
    ],
  },
  {
    label: "Stair Parts",
    subcategories: [
      {
        productCode: 35216,
        name: '3/4" X 7 1/4"-4\' Part. Bd Risers',
      },
      {
        productCode: 35217,
        name: '1 1/8"X11 1/2"-4\' Part.Bd Treads',
      },
      {
        productCode: 1231,
        name: "Lj6010 Oak Col Hdrl 2-1/4X2-3/8",
      },
      {
        productCode: 20835,
        name: "Lj6002 Oak Handrail 1-5/8x2-3/4\"- 16'",
      },
      {
        productCode: 42008,
        name: "Lj6010 Poplar Sc Handrail 8'",
      },
      {
        productCode: 42010,
        name: "Lj6010 Poplar Sc Handrail 10'",
      },
      {
        productCode: 42012,
        name: "Lj6010 Poplar Sc Handrail 12'",
      },
      {
        productCode: 42014,
        name: "Lj6010 Poplar Sc Handrail 14'",
      },
      {
        productCode: 42016,
        name: "Lj6010 Poplar Sc Handrail 16'",
      },
      {
        productCode: 42046,
        name: "Lj6210 Poplar Sc Handrail 16'",
      },
    ],
  },
  {
    label: "Sanded Plywood",
    subcategories: [
      {
        productCode: 1033,
        name: "1/4\"-4'X8' G1Svc Oak Plywood (5.2MM) B2/C3",
      },
      {
        productCode: 1534,
        name: "1/2\"-4'X8' B-2 Vc Poplar Plywood",
      },
      {
        productCode: 30619,
        name: '3/4"-49"X97" Mdf Board',
      },
      {
        productCode: 35666,
        name: "1/4\"-4'X8' Poplar B-4 Vc Plywood",
      },
      {
        productCode: 35667,
        name: "3/4\"-4'X8' Poplar B-2 Vc Plywood",
      },
      {
        productCode: 48156,
        name: "1/4\"-4'X 8' B4 Vc Birch Domestic",
      },
      {
        productCode: 7899,
        name: "3/4\"-4'X8' G2Svc Oak Plywood B2/C2  (18Mm)",
      },
      {
        productCode: 908,
        name: "3/4\"-4'X8' VC Birch IMPORT G2S B2/C2 (18mm)",
      },
    ],
  },
  {
    label: "Miscellaneous",
    subcategories: [
      {
        productCode: 304,
        name: 'Shim Pak (Big One) Cedar 1 1/2" x 16" 42 Pc. Pack',
      },
    ],
  },
];
